import { render } from "./InputDB.vue?vue&type=template&id=0dce650d"
import script from "./InputDB.vue?vue&type=script&lang=js"
export * from "./InputDB.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__